/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageDto } from '../../models/language-dto';

export interface LocalizationLanguagesGet$Plain$Params {
}

export function localizationLanguagesGet$Plain(http: HttpClient, rootUrl: string, params?: LocalizationLanguagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
  const rb = new RequestBuilder(rootUrl, localizationLanguagesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LanguageDto>>;
    })
  );
}

localizationLanguagesGet$Plain.PATH = '/localization/languages';
